<template>
	<div v-loading="loading" class="user-center-container">
		<div class="user-center-content">
			<div class="setting-content">
				<div class="setting-item">
					<label>
						<span>*</span>
						推送方式设置：
					</label>
					<div class="setting-set">
						每日接收动态消息的时间
						<el-time-select
							v-model="detaiInfo.receiveStartHour"
							:picker-options="{
								start: '00:00',
								step: '01:00',
								end: '24:00'
							}"
							placeholder="选择时间"
						></el-time-select>
						至
						<el-time-select
							v-model="detaiInfo.receiveEndHour"
							:picker-options="{
								start: '00:00',
								step: '01:00',
								end: '24:00'
							}"
							placeholder="选择时间"
						></el-time-select>
					</div>
				</div>
				<div class="setting-item">
					<label></label>
					(在该时间段外新增监控消息将不会推送，请设定更大范围的时间段或者直接查看消息通知·监控)
				</div>
				<div class="setting-item setting-center">
					<label>
						<span>*</span>
						平台推送：
					</label>
					<div class="setting-set">
						<el-radio v-model="detaiInfo.homeNoticeEnable" :label="1">首页消息通知</el-radio>
					</div>
				</div>
				<div class="setting-item">
					<label>
						<span>*</span>
						短信通知：
					</label>
					<div class="setting-set">
						<el-radio-group v-model="detaiInfo.messageEnable">
							<el-radio :label="1">开启</el-radio>
							<el-radio :label="0">关闭</el-radio>
						</el-radio-group>
					</div>
				</div>
				<template v-if="detaiInfo.messageEnable === 1">
					<div class="setting-item setting-center">
						<label></label>
						<div class="setting-set">
							接收短信手机号设置
							<el-input v-model="detaiInfo.phoneNumber" placeholder="请输入手机号" :disabled="isDisabled"></el-input>
							<el-button type="text" @click="isDisabled = false">{{ detaiInfo.phoneNumber ? '修改' : '设置' }}</el-button>
						</div>
					</div>
					<div class="setting-item setting-center">
						<label></label>
						<div class="setting-set">
							每日接收全部短信消息数量，最多
							<el-select v-model="detaiInfo.maxTotalAll" placeholder=" ">
								<el-option v-for="item in numberPptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select>
							条
						</div>
					</div>
					<div class="setting-item setting-center">
						<label></label>
						<div class="setting-set">
							每日接收单个对象短信消息数量，最多
							<el-select v-model="detaiInfo.maxTotalSingle" placeholder=" ">
								<el-option v-for="item in numberPptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select>
							条
						</div>
					</div>
				</template>
				<div class="setting-btn" v-if="isSVip">
					<el-button class="submit" @click="saveConfig">确 定</el-button>
				</div>
			</div>
		</div>
		<!-- 未开通超级会员提示 -->
		<NonbindSVip v-if="!isSVip"></NonbindSVip>
	</div>
</template>

<script>
	import NonbindSVip from '@/components/NonBind/nonbindSVip.vue'
	import { mapGetters } from 'vuex'
	import { getUserPushConfig, saveOrUpdateUserPushConfig } from '@/api/user/monitor'

	export default {
		name: 'MonitorMessageSettings',
		components: { NonbindSVip },
		props: {},
		data() {
			return {
				detaiInfo: {
					receiveStartHour: '', // 接收消息的开始时间
					receiveEndHour: '', // 接收消息的结束时间
					homeNoticeEnable: null, // 首页消息通知
					messageEnable: null, // 短信通知
					phoneNumber: '', // 短信接收手机号
					maxTotalAll: 25, // 每日接收全部短信消息数量
					maxTotalSingle: 5 // 每日接收单个对象短信消息数量
				},
				isDisabled: true,
				loading: false
			}
		},
		computed: {
			...mapGetters(['userId', 'vipLevel', 'isNormalVip', 'isVip', 'isSVip']),
			numberPptions: function() {
				let list = []
				for (let i = 5; i <= 50; i++) {
					let data = {
						value: i,
						label: i + ''
					}
					list.push(data)
				}
				return list
			}
		},
		watch: {},
		created() {},
		mounted() {
			if (this.isSVip) {
				this.initUserPushConfig()
			} else {
				// 如果不是svip用户，默认生成一条数据
				this.detaiInfo = {
					id: '427cac69fbe94722bb77e7d6a3fc32b1',
					createBy: null,
					createTime: null,
					updateBy: null,
					updateTime: null,
					rowState: 1,
					remark: null,
					userId: '427cac69fbe94722bb77e7d6a3fc32b1',
					receiveStartHour: '09:00',
					receiveEndHour: '17:00',
					homeNoticeEnable: 1,
					messageEnable: 1,
					phoneNumber: '15623799860',
					maxTotalAll: 25,
					maxTotalSingle: 5
				}
			}
		},
		methods: {
			initUserPushConfig() {
				// TODO: 初始化用户推送配置
				this.loading = true
				getUserPushConfig()
					.then(res => {
						if (res.data) {
							this.detaiInfo = res.data
						}
						this.loading = false
					})
					.catch(err => {
						this.loading = false
					})
			},
			saveConfig() {
				// TODO: 保存用户推送配置
				// 校验手机号
				if (!this.detaiInfo.receiveStartHour && !this.detaiInfo.receiveEndHour) {
					this.$message.error('请设置推送时间')
					return
				}
				if (!this.detaiInfo.homeNoticeEnable && !this.detaiInfo.messageEnable) {
					this.$message.error('请设置推送方式')
					return
				}
				if (!this.detaiInfo.phoneNumber && this.detaiInfo.messageEnable === 1) {
					this.$message.error('请设置短信接收手机号')
					return
				}
				if (this.detaiInfo.phoneNumber && !/^1[3-9]\d{9}$/.test(this.detaiInfo.phoneNumber)) {
					this.$message.error('请输入正确的手机号码')
					return
				}

				const params = {
					userId: this.userId,
					...this.detaiInfo
				}
				saveOrUpdateUserPushConfig(params).then(res => {
					if (res.code == 200) {
						this.$message.success('保存成功')
						this.isDisabled = true
						this.initUserPushConfig()
					} else {
						this.$message.warning(res.message)
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '~@/views/user/styles/user-center.scss';
	.user-center-container {
		position: relative;
	}
	.setting-item {
		display: flex;
		margin-bottom: 10px;
		label {
			width: 130px;
			margin-right: 12px;
			display: inline-block;
			text-align: right;
			span {
				color: #ff0000;
			}
		}
		.setting-set {
			::v-deep {
				.el-input {
					width: 210px;
					margin: 0px 10px;
				}
				.is-disabled {
					background-color: #f5f7fa;
					border-color: #e4e7ed;
					color: #c0c4cc;
					cursor: not-allowed;
				}
				.el-input__inner {
					width: 100%;
					height: 36px;
					border-radius: 0px;
					border: solid 1px #cccccc;
					width: 100%;
					margin-top: -9px;
				}
				.el-input__prefix {
					top: -9px;
				}
				.el-radio {
					text-align: left;
					width: 60px;
				}
				.el-select {
					.el-input {
						width: 60px;
						.el-input__prefix {
							top: 3cap;
						}
					}
				}
			}
		}
	}
	.setting-center {
		align-items: center;
		margin-bottom: 20px;
	}
	.setting-btn {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 30px;
		.el-button {
			width: 154px;
			height: 50px;
			border-radius: 6px;
			font-size: 18px;
		}
		.submit {
			background-color: #236fca;
			color: #ffffff;
		}
	}
</style>
